import { Component } from '@angular/core';

@Component({
  selector: 'app-assets-count-chart',
  templateUrl: './assets-count-chart.component.html',
  styleUrls: ['./assets-count-chart.component.scss'],
})
export class AssetsCountChartComponent {}
